export default __webpack_public_path__ + "static/media/password-lock.44e114ed.svg";